import React, { useRef, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import Cookies from "js-cookie";
import { redressWidget } from "../../api";
import { renameZoneWidget } from "../../redux";
import { Alert } from "../";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { IconsList } from ".";
import { ModalComp } from "../";
import { FiEdit, FiEye, FiEyeOff, FiCheck, FiArrowLeft, FiImage } from "react-icons/fi";

const EditWidgetComp = (props) => {
  const { t } = useTranslation();
  const [openIconModal, setOpenIconModal] = useState(false);
  const toggleIcon = () => setOpenIconModal(!openIconModal);
  const { zone, toggleEdit } = props;
  const dispatch = useDispatch();
  const icons = useSelector((state) => state.icons);
  let form = useRef();
  let caption = useRef();
  const token = Cookies.get("token");
  const [widgetStatus, setWidgetStatus] = useState(zone.property[4]);
  const [icon, setIcon] = useState(
    zone.property[2] === "image_path"
      ? "https://assessn.mmaviot.com/icon/app/005-smart-control.png"
      : zone.property[2]
  );
  const [visible, setVisible] = useState(zone.property[3]);

  const initialValues = {
    caption: zone.caption,
    configuration: zone.property[4],
  };

  const visibleChanged = (e) => {
    if (e.target.checked) {
      setVisible("0");
    } else {
      setVisible("1");
    }
  };

  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const submitForm = (val) => {
    const data = new FormData(form.current);
    data.append("serial", zone.serial);
    data.append("widget", zone.id);
    data.append("icon", icon);
    data.append("visible", visible);
    redressWidget(data, token)
      .then(() => {
        setShowAlert({
          show: true,
          message: t("ویجت با موفقیت ویرایش شد."),
          type: "Success",
        });
        setTimeout(() => {
          setShowAlert((prev) => ({ ...prev, show: false }));
          toggleEdit();
          dispatch(
            renameZoneWidget({
              genome: zone.genome,
              caption: val.caption,
              visible: visible,
              configuration: val.configuration,
              icon: icon,
            })
          );
        }, 2000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert({
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          });
          setTimeout(() => {
            setShowAlert((prev) => ({ ...prev, show: false }));
          }, 2000);
        }
      });
  };

  const validationSchema = Yup.object({
    caption: Yup.string().required(t("نام ویجت را وارد کنید.")),
    configuration: Yup.string().required(t("تنظیمات ویجت را وارد کنید.")),
  });

  return (
    <>
      <ModalComp
        modal={openIconModal}
        toggle={toggleIcon}
        component={
          <IconsList icons={icons} toggleIcon={toggleIcon} setIcon={setIcon} />
        }
      />
      <div className="setting-container" style={{ minHeight: "auto", padding: "24px" }}>
        <h2 className="setting-title">{t("ویرایش ویجت")}</h2>

        {/* Widget Info Card */}
        <div className="schedule-command-info" style={{ marginBottom: "24px" }}>
          <div className="schedule-command-icon">
            <FiEdit size={24} />
          </div>
          <div>
            <p className="schedule-command-label">{zone.caption}</p>
            <p className="schedule-zone-name">{zone.property[1] || t("ویجت")}</p>
          </div>
        </div>

        <Formik
          initialValues={initialValues}
          onSubmit={submitForm}
          validationSchema={validationSchema}
        >
          {(formProps) => (
            <Form ref={form}>
              {/* Widget Name Field */}
              <div className="setting-item" style={{ flexDirection: "column", alignItems: "stretch", gap: "12px" }}>
                <div className="setting-item-label">
                  <FiEdit size={16} />
                  <span>{t("نام ویجت")}</span>
                </div>
                <input
                  type="text"
                  placeholder={t("نام ویجت")}
                  name="caption"
                  className="setting-input"
                  defaultValue={formProps.values.caption}
                  onChange={formProps.handleChange}
                  onBlur={formProps.handleBlur}
                  ref={caption}
                />
                <ErrorMessage name="caption">
                  {(errMsg) => <div className="setting-error">{errMsg}</div>}
                </ErrorMessage>
              </div>

              {/* Widget Status (Configuration) */}
              <div className="setting-item" style={{ flexDirection: "column", alignItems: "stretch", gap: "12px" }}>
                <div className="setting-item-label">
                  <FiEye size={16} />
                  <span>{t("وضعیت ویجت")}</span>
                </div>
                <div className="radio-group">
                  <label className="radio-label">
                    <input
                      type="radio"
                      value="Conf1"
                      name="configuration"
                      className="radio-input"
                      onChange={formProps.handleChange}
                      onClick={() => setWidgetStatus("Conf1")}
                      onBlur={formProps.handleBlur}
                      defaultChecked={zone.property[4] === "Conf1"}
                    />
                    <span className="radio-text">{t("خاموش و روشن")}</span>
                  </label>
                  {zone.commands.length > 2 && (
                    <label className="radio-label">
                      <input
                        type="radio"
                        value="Conf2"
                        name="configuration"
                        className="radio-input"
                        onChange={formProps.handleChange}
                        onClick={() => setWidgetStatus("Conf2")}
                        onBlur={formProps.handleBlur}
                        defaultChecked={zone.property[4] === "Conf2"}
                      />
                      <span className="radio-text">{t("تحریک")}</span>
                    </label>
                  )}
                </div>
                <ErrorMessage name="configuration">
                  {(errMsg) => <div className="setting-error">{errMsg}</div>}
                </ErrorMessage>
              </div>

              {/* Widget Icon */}
              <div className="setting-item">
                <div className="setting-item-label">
                  <FiImage size={16} />
                  <span>{t("آیکون ویجت")}</span>
                </div>
                <div
                  onClick={toggleIcon}
                  className="icon-picker-btn"
                >
                  <img width="24" height="24" src={icon} alt="icon" />
                  <span>{t("تغییر")}</span>
                </div>
              </div>

              {/* Hide Widget Toggle */}
              <div className="setting-item">
                <div className="setting-item-label">
                  {visible === "0" ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                  <span>{t("ویجت پنهان")}</span>
                </div>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    defaultChecked={visible === "0"}
                    onChange={visibleChanged}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>

              {/* Action Buttons */}
              <div className="setting-buttons">
                <button
                  type="button"
                  className="setting-back-btn"
                  onClick={toggleEdit}
                  style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
                >
                  <FiArrowLeft size={18} />
                  <span>{t("انصراف")}</span>
                </button>
                <button type="submit" className="setting-back-btn">
                  <FiCheck size={18} />
                  <span>{t("ذخیره")}</span>
                </button>
              </div>
            </Form>
          )}
        </Formik>

        {showAlert.show && (
          <Alert message={showAlert.message} type={showAlert.type} />
        )}
      </div>
    </>
  );
};

const EditWidget = withRouter(EditWidgetComp);

export { EditWidget };